// Initialize Glassbox
declare global {
  interface Window {
    _detector?: any
  }
}
export const initGlassbox = (): void => {
  console.log(process.env.REACT_APP_ENVIRONMENT)
  if (
    !document.getElementById('glassbox-sdk') &&
    process.env.REACT_APP_ENVIRONMENT &&
    process.env.REACT_APP_ENVIRONMENT !== 'local'
  ) {
    const script = document.createElement('script')
    script.id = 'glassbox-sdk'
    script.async = true
    script.src =
      process.env.REACT_APP_ENVIRONMENT === 'prod'
        ? '/libs/glassbox/p/detector-dom.min.js'
        : '/libs/glassbox/u/detector-dom.min.js'
    document.body.appendChild(script)
  }
}
